const selectClickSyncSettings = state => state.experiences.clickSyncSettings.settings

const ClickSyncSettingsExperienceSelectors = {
  clickSyncSettings: selectClickSyncSettings
}

export default ClickSyncSettingsExperienceSelectors
